import { useRef, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";

/**
 * Icono de configuración que redirige a /new_payments/:business_code/:branchoffice_code
 * después de 5 clics seguidos (máximo 2 segundos entre cada clic).
 *
 * Props opcionales:
 *  - business_code / branchoffice_code: si no se pasan, se toman de la URL actual (useParams)
 *  - clicksRequired: cantidad de clics (default 5)
 *  - resetMs: tiempo máximo entre clics antes de reiniciar el contador (default 2000)
 *  - className: clases extra para el icono
 */
export default function SecretSettingsIcon({
    business_code,
    branchoffice_code,
    clicksRequired = 5,
    resetMs = 2000,
    className = "",
}) {
    const navigate = useNavigate();
    const params = useParams();
    const clicks = useRef(0);
    const timer = useRef(null);

    const business = business_code ?? params.business_code;
    const branch = branchoffice_code ?? params.branchoffice_code;

    useEffect(() => () => clearTimeout(timer.current), []);

    const handleClick = () => {
        clicks.current += 1;
        clearTimeout(timer.current);

        if (clicks.current >= clicksRequired) {
            clicks.current = 0;
            navigate(`/new_payments/${business}/${branch}`);
            return;
        }

        timer.current = setTimeout(() => {
            clicks.current = 0;
        }, resetMs);
    };

    return (
        <i
            className={`uil uil-setting ${className}`}
            onClick={handleClick}
            style={{ cursor: "pointer", userSelect: "none" }}
        />
    );
}